import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { TaskSession, TaskStage } from '@tailorcast/shared-types';

const ACTIVE_STAGES: TaskStage[] = [
  'created',
  'diagnosing',
  'planning',
  'executing',
  'revising',
  'monitoring',
];

export function useTaskDetail(taskId: string | undefined) {
  return useQuery({
    queryKey: ['task', taskId],
    queryFn: () => api.get<TaskSession>(TASKS.DETAIL(taskId!)),
    enabled: !!taskId,
    refetchInterval: (query) => {
      const stage = query.state.data?.stage;
      if (stage && ACTIVE_STAGES.includes(stage)) return 2000;
      return false;
    },
  });
}
